import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Char_wrap$SolvuuLang0 from "solvuu-lang0/./char_wrap.bs.js";

function write__1(param) {
  return Atdgen_codec_runtime.Encode.contramap(Char_wrap$SolvuuLang0.unwrap, Atdgen_codec_runtime.Encode.string, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.map(Char_wrap$SolvuuLang0.wrap, Atdgen_codec_runtime.Decode.string, param);
}

function write__2(param) {
  return Atdgen_codec_runtime.Encode.list(Atdgen_codec_runtime.Encode.string, param);
}

function read__2(param) {
  return Atdgen_codec_runtime.Decode.list(Atdgen_codec_runtime.Decode.string, param);
}

var write_t = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x >= 3654863) {
    if (x >= 487611253) {
      if (x >= 748691835) {
        if (x >= 793449722) {
          if (x >= 826371656) {
            if (x >= 962246961) {
              return Atdgen_codec_runtime.Encode.constr0("Ascii");
            } else {
              return Atdgen_codec_runtime.Encode.constr0("Json");
            }
          } else if (x >= 804241803) {
            return Atdgen_codec_runtime.Encode.constr0("Html");
          } else {
            return Atdgen_codec_runtime.Encode.constr0("Gzip");
          }
        } else if (x >= 758940238) {
          return Atdgen_codec_runtime.Encode.constr0("Date");
        } else {
          return Atdgen_codec_runtime.Encode.constr0("Cram");
        }
      } else if (x !== 642196241) {
        if (x >= 737157829) {
          if (x >= 737456202) {
            return Atdgen_codec_runtime.Encode.constr0("Bool");
          } else {
            return Atdgen_codec_runtime.Encode.constr0("Biom");
          }
        } else if (x >= 736760884) {
          return Atdgen_codec_runtime.Encode.constr0("Bash");
        } else {
          return Atdgen_codec_runtime.Encode.constr0("Bigwig");
        }
      } else {
        return Atdgen_codec_runtime.Encode.constr0("Newick");
      }
    } else if (x >= 107576104) {
      if (x >= 243398197) {
        if (x >= 374637448) {
          if (x >= 486566049) {
            return Atdgen_codec_runtime.Encode.constr0("Bigbed");
          } else {
            return Atdgen_codec_runtime.Encode.constr0("Maybe");
          }
        } else if (x >= 365180284) {
          return Atdgen_codec_runtime.Encode.constr0("Float");
        } else {
          return Atdgen_codec_runtime.Encode.constr0("Fastq");
        }
      } else if (x >= 243398181) {
        return Atdgen_codec_runtime.Encode.constr0("Fasta");
      } else {
        return Atdgen_codec_runtime.Encode.constr0("Solvuu_runtime_json");
      }
    } else if (x !== 4002953) {
      if (x >= 4149247) {
        if (x >= 4298873) {
          return Atdgen_codec_runtime.Encode.constr0("Vcf");
        } else {
          return Atdgen_codec_runtime.Encode.constr0("Sam");
        }
      } else if (x >= 4055352) {
        return Atdgen_codec_runtime.Encode.constr0("Qza");
      } else {
        return Atdgen_codec_runtime.Encode.constr0("Int");
      }
    } else {
      return Atdgen_codec_runtime.Encode.constr0("Png");
    }
  } else if (x >= -293895564) {
    if (x >= -4561036) {
      if (x >= 3304737) {
        if (x >= 3553607) {
          if (x >= 3556729) {
            return Atdgen_codec_runtime.Encode.constr0("Gtf");
          } else {
            return Atdgen_codec_runtime.Encode.constr0("Gff");
          }
        } else if (x >= 3357606) {
          return Atdgen_codec_runtime.Encode.constr0("Csv");
        } else {
          return Atdgen_codec_runtime.Encode.constr0("Bed");
        }
      } else if (x >= 3303854) {
        return Atdgen_codec_runtime.Encode.constr0("Bam");
      } else {
        return Atdgen_codec_runtime.Encode.constr0("Solvuu_fmt");
      }
    } else if (x !== -113318020) {
      if (x >= -56835286) {
        if (x >= -50740607) {
          return Atdgen_codec_runtime.Encode.constr0("Bam_index");
        } else {
          return Atdgen_codec_runtime.Encode.constr0("Solvuu_dataframe");
        }
      } else if (x >= -77614959) {
        return Atdgen_codec_runtime.Encode.constr0("Solvuu_bigdata");
      } else {
        return Atdgen_codec_runtime.Encode.constr0("Solvuu_type_json");
      }
    } else {
      return Atdgen_codec_runtime.Encode.constr0("Rdata");
    }
  } else if (x >= -953902196) {
    if (x >= -792364981) {
      if (x >= -574959090) {
        if (x >= -522825178) {
          return Atdgen_codec_runtime.Encode.constr0("Solvuu");
        } else {
          return Atdgen_codec_runtime.Encode.constr0("Cram_index");
        }
      } else if (x >= -619744749) {
        return Atdgen_codec_runtime.Encode.constr0("Solvuu_fmt_json");
      } else {
        return Atdgen_codec_runtime.Encode.constr0("Bytes");
      }
    } else if (x >= -861261133) {
      return Atdgen_codec_runtime.Encode.constr0("Solvuu_type");
    } else {
      return Atdgen_codec_runtime.Encode.constr0("Vcf_index");
    }
  } else if (x !== -1015245230) {
    if (x >= -973518485) {
      if (x >= -972455391) {
        return Atdgen_codec_runtime.Encode.constr0("Solvuu_json");
      } else {
        return Atdgen_codec_runtime.Encode.constr0("MultiQC");
      }
    } else if (x >= -976970511) {
      return Atdgen_codec_runtime.Encode.constr0("String");
    } else {
      return Atdgen_codec_runtime.Encode.constr0("Fasta_index");
    }
  } else {
    return Atdgen_codec_runtime.Encode.constr0("Solvuu_eval_json");
  }
});
var read_t = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Ascii",
/* `Single */
[-306849112,
/* Ascii */
962246961]],
/* :: */
[
/* tuple */
["Bam",
/* `Single */
[-306849112,
/* Bam */
3303854]],
/* :: */
[
/* tuple */
["Bam_index",
/* `Single */
[-306849112,
/* Bam_index */
-50740607]],
/* :: */
[
/* tuple */
["Bash",
/* `Single */
[-306849112,
/* Bash */
736760884]],
/* :: */
[
/* tuple */
["Bed",
/* `Single */
[-306849112,
/* Bed */
3304737]],
/* :: */
[
/* tuple */
["Bigbed",
/* `Single */
[-306849112,
/* Bigbed */
486566049]],
/* :: */
[
/* tuple */
["Bigwig",
/* `Single */
[-306849112,
/* Bigwig */
487611253]],
/* :: */
[
/* tuple */
["Biom",
/* `Single */
[-306849112,
/* Biom */
737157829]],
/* :: */
[
/* tuple */
["Bool",
/* `Single */
[-306849112,
/* Bool */
737456202]],
/* :: */
[
/* tuple */
["Bytes",
/* `Single */
[-306849112,
/* Bytes */
-792364981]],
/* :: */
[
/* tuple */
["Cram",
/* `Single */
[-306849112,
/* Cram */
748691835]],
/* :: */
[
/* tuple */
["Cram_index",
/* `Single */
[-306849112,
/* Cram_index */
-574959090]],
/* :: */
[
/* tuple */
["Csv",
/* `Single */
[-306849112,
/* Csv */
3357606]],
/* :: */
[
/* tuple */
["Date",
/* `Single */
[-306849112,
/* Date */
758940238]],
/* :: */
[
/* tuple */
["Fasta",
/* `Single */
[-306849112,
/* Fasta */
243398181]],
/* :: */
[
/* tuple */
["Fasta_index",
/* `Single */
[-306849112,
/* Fasta_index */
-1040940488]],
/* :: */
[
/* tuple */
["Fastq",
/* `Single */
[-306849112,
/* Fastq */
243398197]],
/* :: */
[
/* tuple */
["Float",
/* `Single */
[-306849112,
/* Float */
365180284]],
/* :: */
[
/* tuple */
["Gff",
/* `Single */
[-306849112,
/* Gff */
3553607]],
/* :: */
[
/* tuple */
["Gtf",
/* `Single */
[-306849112,
/* Gtf */
3556729]],
/* :: */
[
/* tuple */
["Gzip",
/* `Single */
[-306849112,
/* Gzip */
793449722]],
/* :: */
[
/* tuple */
["Html",
/* `Single */
[-306849112,
/* Html */
804241803]],
/* :: */
[
/* tuple */
["Int",
/* `Single */
[-306849112,
/* Int */
3654863]],
/* :: */
[
/* tuple */
["Json",
/* `Single */
[-306849112,
/* Json */
826371656]],
/* :: */
[
/* tuple */
["Maybe",
/* `Single */
[-306849112,
/* Maybe */
374637448]],
/* :: */
[
/* tuple */
["MultiQC",
/* `Single */
[-306849112,
/* MultiQC */
-973518485]],
/* :: */
[
/* tuple */
["Newick",
/* `Single */
[-306849112,
/* Newick */
642196241]],
/* :: */
[
/* tuple */
["Png",
/* `Single */
[-306849112,
/* Png */
4002953]],
/* :: */
[
/* tuple */
["Qza",
/* `Single */
[-306849112,
/* Qza */
4055352]],
/* :: */
[
/* tuple */
["Rdata",
/* `Single */
[-306849112,
/* Rdata */
-113318020]],
/* :: */
[
/* tuple */
["Sam",
/* `Single */
[-306849112,
/* Sam */
4149247]],
/* :: */
[
/* tuple */
["Solvuu",
/* `Single */
[-306849112,
/* Solvuu */
-522825178]],
/* :: */
[
/* tuple */
["Solvuu_bigdata",
/* `Single */
[-306849112,
/* Solvuu_bigdata */
-77614959]],
/* :: */
[
/* tuple */
["Solvuu_dataframe",
/* `Single */
[-306849112,
/* Solvuu_dataframe */
-56835286]],
/* :: */
[
/* tuple */
["Solvuu_eval_json",
/* `Single */
[-306849112,
/* Solvuu_eval_json */
-1015245230]],
/* :: */
[
/* tuple */
["Solvuu_fmt",
/* `Single */
[-306849112,
/* Solvuu_fmt */
-4561036]],
/* :: */
[
/* tuple */
["Solvuu_fmt_json",
/* `Single */
[-306849112,
/* Solvuu_fmt_json */
-619744749]],
/* :: */
[
/* tuple */
["Solvuu_json",
/* `Single */
[-306849112,
/* Solvuu_json */
-972455391]],
/* :: */
[
/* tuple */
["Solvuu_runtime_json",
/* `Single */
[-306849112,
/* Solvuu_runtime_json */
107576104]],
/* :: */
[
/* tuple */
["Solvuu_type",
/* `Single */
[-306849112,
/* Solvuu_type */
-861261133]],
/* :: */
[
/* tuple */
["Solvuu_type_json",
/* `Single */
[-306849112,
/* Solvuu_type_json */
-293895564]],
/* :: */
[
/* tuple */
["String",
/* `Single */
[-306849112,
/* String */
-976970511]],
/* :: */
[
/* tuple */
["Vcf",
/* `Single */
[-306849112,
/* Vcf */
4298873]],
/* :: */
[
/* tuple */
["Vcf_index",
/* `Single */
[-306849112,
/* Vcf_index */
-953902196]],
/* [] */
0]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]);

function write__3(js) {
  return Atdgen_codec_runtime.Encode.list(write_cst, js);
}

function write__4(js) {
  return Atdgen_codec_runtime.Encode.list(function (param) {
    return Atdgen_codec_runtime.Encode.tuple2(Atdgen_codec_runtime.Encode.string, write_cst, param);
  }, js);
}

function write__5(js) {
  return Atdgen_codec_runtime.Encode.nullable(write_attribute, js);
}

function write__7(js) {
  return Atdgen_codec_runtime.Encode.nullable(write_cst, js);
}

function write_attribute(js) {
  return Curry._1(Atdgen_codec_runtime.Encode.make(function (x) {
    var variant = x[0];

    if (variant >= 3654863) {
      if (variant >= 737456202) {
        if (variant >= 748194550) {
          return Atdgen_codec_runtime.Encode.constr1("Char", write__1, x[1]);
        } else {
          return Atdgen_codec_runtime.Encode.constr1("Bool", Atdgen_codec_runtime.Encode.bool, x[1]);
        }
      } else if (variant >= 81967494) {
        return Atdgen_codec_runtime.Encode.constr1("Format_list", write__3, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Int", Atdgen_codec_runtime.Encode.$$int, x[1]);
      }
    } else if (variant !== -691269204) {
      if (variant >= -6752610) {
        return Atdgen_codec_runtime.Encode.constr1("Format_dict", write__4, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("String", Atdgen_codec_runtime.Encode.string, x[1]);
      }
    } else {
      return Atdgen_codec_runtime.Encode.constr1("String_list", write__2, x[1]);
    }
  }), js);
}

function write_attributes(js) {
  var js$1 = js;
  return Atdgen_codec_runtime.Encode.list(function (param) {
    return Atdgen_codec_runtime.Encode.tuple2(Atdgen_codec_runtime.Encode.string, write__5, param);
  }, js$1);
}

function write_cst(js) {
  return Curry._1(Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Fmt", function (param) {
      return Atdgen_codec_runtime.Encode.tuple3(write_t, write_attributes, write__7, param);
    }, x[1]);
  }), js);
}

function read__3(js) {
  return Atdgen_codec_runtime.Decode.list(read_cst, js);
}

function read__4(js) {
  return Atdgen_codec_runtime.Decode.list(function (param) {
    return Atdgen_codec_runtime.Decode.tuple2(Atdgen_codec_runtime.Decode.string, read_cst, param);
  }, js);
}

function read__5(js) {
  return Atdgen_codec_runtime.Decode.nullable(read_attribute, js);
}

function read__7(js) {
  return Atdgen_codec_runtime.Decode.nullable(read_cst, js);
}

function read_attribute(js) {
  return Curry._1(Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Bool",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Bool */
        [737456202, x]
      );
    }, Atdgen_codec_runtime.Decode.bool, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Char",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Char */
        [748194550, x]
      );
    }, read__1, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Int",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int */
        [3654863, x]
      );
    }, Atdgen_codec_runtime.Decode.$$int, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["String",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `String */
        [-976970511, x]
      );
    }, Atdgen_codec_runtime.Decode.string, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["String_list",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `String_list */
        [-691269204, x]
      );
    }, read__2, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Format_list",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Format_list */
        [81967494, x]
      );
    }, read__3, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Format_dict",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Format_dict */
        [-6752610, x]
      );
    }, read__4, param);
  }]],
  /* [] */
  0]]]]]]]), js);
}

function read_attributes(js) {
  var js$1 = js;
  return Atdgen_codec_runtime.Decode.list(function (param) {
    return Atdgen_codec_runtime.Decode.tuple2(Atdgen_codec_runtime.Decode.string, read__5, param);
  }, js$1);
}

function read_cst(js) {
  return Curry._1(Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Fmt",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Fmt */
        [3505453, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple3(read_t, read_attributes, read__7, param);
    }, param);
  }]],
  /* [] */
  0]), js);
}

export { read_t, write_t, read_attribute, write_attribute, read_attributes, write_attributes, read_cst, write_cst };
/* write_t Not a pure module */